import { useEffect, useState } from "react";

/**
 * Feature 4 - Blur When Page Becomes Hidden (Page Visibility API).
 *
 * Detects tab switches, browser minimize, window hide, and mobile app switch.
 * Reports whether the page is currently visible. When `enabled` is false it
 * reports visible = true (never blurs).
 *
 * @param {object} opts
 * @param {boolean} opts.enabled
 * @param {(visible: boolean) => void} [opts.onChange]
 */
export function usePageVisibility({ enabled, onChange } = {}) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (!enabled) {
      setIsVisible(true);
      return undefined;
    }

    const handleChange = () => {
      const visible = !document.hidden;
      setIsVisible(visible);
      if (typeof onChange === "function") onChange(visible);
    };

    document.addEventListener("visibilitychange", handleChange, false);
    handleChange();

    return () => {
      document.removeEventListener("visibilitychange", handleChange, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);

  return { isVisible };
}

export default usePageVisibility;
